exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rango1{background-color:var(--clima-1)!important;color:#fff!important}.rango2{background-color:var(--clima-2)!important}.rango2,.rango3{color:rgba(65,64,64,.91)}.rango3{background-color:var(--clima-3)!important}.rango4{background-color:var(--clima-4)!important}.rango4,.rango5{color:rgba(65,64,64,.91)}.rango5{background-color:var(--clima-5)!important}.rango6{background-color:var(--clima-6)!important;color:rgba(65,64,64,.91)}.rango0{background-color:#a5a5a5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-135e3742","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/climan/components/menuInterpretacion.vue
// module id = 1399
// module chunks = 2